export default __webpack_public_path__ + "static/media/supply.259763af.svg";